module.exports = __webpack_public_path__ + "img/header-weddingRingsStarrySky.d18a2f0.jpg";